module.exports = __webpack_public_path__ + "static/media/grid-item-a5.c5ff2332.png";